import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import ReactModal from 'react-modal';

import renderIcon from '../../utils/renderIcon';

// Setup app element for react-modal
ReactModal.setAppElement('#___gatsby');

const ns = `site-modal`;

const Modal = ({
	children,
	variant,
	cart,
	whiteCloseButton,
	contentLabel = '',
	isOpen = false,
	onRequestClose,
	className,
	overlayClass,
	overlayTransition = 400,
	...props
}) => {
	const [openState, setIsOpenState] = useState(false);
	const [viewportHeight, setViewportHeight] = useState();

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--${ variant }`]: variant,
		[`${ ns }--white`]: whiteCloseButton,
		[className]: className,
	});

	const handleCloseModal = () => {
		if (onRequestClose && typeof onRequestClose === 'function') {
			onRequestClose();
		} else {
			setIsOpenState(false);
		}
	};

	const handleOnAfterClose = () => {
		const bodyEl = document.body;
		bodyEl.style.paddingRight = `0px`;
	};

	const handleMenuOpen = () => {
		const bodyEl = document.body;
		const scrollbarWidth = (window.innerWidth - bodyEl.clientWidth);
		bodyEl.style.paddingRight = `${ scrollbarWidth }px`;
	};

	const overlayClassName = classNames({
		[`${ ns }__overlay`]: true,
		[`${ ns }__overlay--${ variant }`]: variant,
		[`${ ns }__overlay--${ variant }-cart`]: cart,
		[overlayClass]: overlayClass,
	});

	useEffect(() => {
		if (isOpen) handleMenuOpen();

		setIsOpenState(isOpen);
	}, [isOpen]);

	useEffect(() => {
		setViewportHeight(window.innerHeight);
		const handleResize = () => setViewportHeight(() => window.innerHeight);

		window.addEventListener('resize', handleResize);

		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<ReactModal
			contentLabel={contentLabel}
			className={rootClassnames}
			bodyOpenClassName={`${ ns }--open`}
			overlayClassName={overlayClassName}
			isOpen={openState}
			onRequestClose={handleCloseModal}
			onAfterClose={handleOnAfterClose}
			closeTimeoutMS={overlayTransition}
			{...props}
		>
			<div
				className={`${ ns }__content-inner`}
				style={{
					height: cart || variant === 'drawer' ? `${ viewportHeight }px` : '100%',
				}}
			>
				<button
					className={`${ ns }__close`}
					onClick={handleCloseModal}
				>
					{renderIcon('close')}
					<span className={`visually-hidden`}>Close</span>
				</button>
				{children}
			</div>
		</ReactModal>
	);
};

export default Modal;
